// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"309":"3ee6cfc2","475":"aab71a02","488":"12802ace","525":"41bfd2d4","653":"82443dcb","874":"22be077d"}[chunkId] + ".chunk.js";
};